// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ViewListSection_wrapper__xp0uv"};